export default function TimelineItem({ data, timelineIcon }) {
  return (
    <li className="relative w-full border-l-4 border-portfolio-line [border-left-style:solid] pb-4 pl-8 max-[1200px]:pl-[1.4rem]">
      <div className="absolute left-[-15px] top-[15px] flex size-[26px] items-center justify-center rounded-full bg-portfolio-line [&>svg]:w-3 [&>svg]:fill-portfolio-inverse">
        {timelineIcon}
      </div>

      <div className="rounded-lg bg-portfolio-page p-4 max-[1024px]:p-3">
        <div className="flex items-center gap-4 max-[1024px]:flex-col max-[1024px]:items-center">
          <img
            className="size-[70px] rounded-full"
            src={data.imgSrc}
            alt={data.altText}
          />
          <div className="flex flex-col gap-2">
            <h4 className="text-sm font-normal">
              <span>{data.title}</span>
              <span>{" | "}</span>
              <span className="italic text-sm">{data.italicsTitle}</span>
            </h4>
            <div className="flex flex-wrap items-center gap-1">
              {data.tags.map((tag, index) => (
                <span
                  key={index}
                  className="whitespace-nowrap rounded-md bg-portfolio-accent px-2 py-1 text-xs text-portfolio-inverse"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
        {data?.description && (
          <div className="mt-3">
            <p className="text-xs">{data?.description}</p>
          </div>
        )}
      </div>
    </li>
  );
}
